import { render, staticRenderFns } from "./ThinCard.vue?vue&type=template&id=8993fb76&scoped=true&"
import script from "./ThinCard.vue?vue&type=script&lang=js&"
export * from "./ThinCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8993fb76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8993fb76')) {
      api.createRecord('8993fb76', component.options)
    } else {
      api.reload('8993fb76', component.options)
    }
    module.hot.accept("./ThinCard.vue?vue&type=template&id=8993fb76&scoped=true&", function () {
      api.rerender('8993fb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/ThinCard.vue"
export default component.exports